<template>
  <p-edit-prompt v-if="$hasPermission('prompts.read')" />
  <p-not-found v-else />
</template>

<script>
import EditContentChain from '@/components/chains/EditContentChain.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-edit-prompt': EditContentChain,
    'p-not-found': NotFound
  }
};
</script>
